import React from 'react'
import "./Gallery.css";

import img1 from "../../assets/img/img1.png";
import img2 from "../../assets/img/img2.png";
import img3 from "../../assets/img/img3.png";

const gallery = () => {
  return (
    <div className="gallery-container">
      <img src={img1} alt="" className="img-g" />
      <img src={img2} alt="" className="img-g" />
      <img src={img3} alt="" className="img-g" />
    </div>
  );
}

export default gallery